module.exports = __webpack_public_path__ + "img/262-2.7dda94f7.jpg";